import InsightCard from "@/components/chat/InsightCard.tsx";
import { Button } from "@/components/ui/button.tsx";
import { getDeepInsightsSummary } from "@/lib/serverComm.tsx";
import { DeepInsightSummary } from "@/types/deep-insights.ts";
import { ArrowRight } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const DeepInsights: React.FC<unknown> = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [insights, setInsights] = useState<DeepInsightSummary[] | null>(null);

  useEffect(() => {
    if (isLoading || insights !== null) {
      return;
    }

    reload().then();
  }, [isLoading, insights]);

  const reload = async () => {
    setIsLoading(true);

    const response = await getDeepInsightsSummary();
    setIsLoading(false);
    setInsights(response);
  };

  return (
    <div className="mt-28">
      <h1 className="text-center text-3xl font-bold text-sky-500 mb-8">
        Deep Insights
      </h1>

      <div className="flex gap-6">
        {isLoading || insights === null ? (
          <p>Loading...</p>
        ) : (
          insights.map((insight) => (
            <InsightCard
              key={insight.id}
              id={insight.id}
              chip={insight.chip}
              category={insight.category}
              title={insight.title}
              description={""}
              date={insight.date}
              isPinned={insight.isPinned}
              isArchived={insight.isArchived}
              reload={reload}
            />
          ))
        )}
      </div>

      <div className="mt-8 mb-8 flex justify-center">
        <Link to="/deep-insights" className="block">
          <Button className="bg-sky-500 rounded-full w-64 justify-normal">
            <span className="flex-1">View All</span>
            <ArrowRight size={18} className="justify-self-end" />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default DeepInsights;
